export const promotions = [
  {
    id: 1,
    title: '首充豪礼100%',
    description: '新用户首次充值即享100%赠送，最高8888元',
    icon: 'ri-gift-2-line',
    color: 'accent',
  },
  {
    id: 2,
    title: '每日签到有礼',
    description: '每日签到领免费筹码，连续7天额外惊喜',
    icon: 'ri-calendar-check-line',
    color: 'primary',
  },
  {
    id: 3,
    title: '推荐好友奖励',
    description: '邀请好友注册充值，双方各得88元奖励',
    icon: 'ri-user-add-line',
    color: 'accent',
  },
  {
    id: 4,
    title: 'VIP专属特权',
    description: 'VIP会员享专属客服、优先提款、生日礼金',
    icon: 'ri-vip-crown-line',
    color: 'primary',
  },
  {
    id: 5,
    title: '体育竞猜返水',
    description: '体育竞猜每周返水最高1.2%，无上限',
    icon: 'ri-football-line',
    color: 'accent',
  },
  {
    id: 6,
    title: '老虎机免费转',
    description: '新上线老虎机赠送50次免费旋转机会',
    icon: 'ri-gamepad-line',
    color: 'primary',
  },
];

export const advantages = [
  {
    id: 1,
    title: '安全可靠',
    description: '采用国际领先的SSL加密技术，资金交易全程护航，确保每位玩家的信息和资金安全。',
    icon: 'ri-shield-check-line',
  },
  {
    id: 2,
    title: '存取便捷',
    description: '支持多种支付方式，存款即时到账，提款最快5分钟处理完成，让您畅享无忧体验。',
    icon: 'ri-bank-card-line',
  },
  {
    id: 3,
    title: '游戏丰富',
    description: '500+精选游戏，涵盖真人娱乐、老虎机、体育竞猜、彩票、棋牌等全品类，总有您喜欢的。',
    icon: 'ri-gamepad-line',
  },
  {
    id: 4,
    title: '客服在线',
    description: '7×24小时专业客服团队，3分钟快速响应，全方位解决您的问题与需求。',
    icon: 'ri-customer-service-2-line',
  },
  {
    id: 5,
    title: '公平公正',
    description: '所有游戏均采用国际认证的随机数生成器，确保游戏结果公平公正、不可操控。',
    icon: 'ri-scales-line',
  },
  {
    id: 6,
    title: '优惠丰厚',
    description: '定期推出各类优惠活动，首充赠送、每日签到、推荐奖励等多重好礼等您来拿。',
    icon: 'ri-coupon-line',
  },
];

export const faqs = [
  {
    question: '新葡京娱乐城是否合法安全？',
    answer: '新葡京娱乐城持有国际合法运营牌照，采用SSL加密技术保护用户信息和资金安全，所有游戏经过第三方机构认证，确保公平公正。',
  },
  {
    question: '如何注册新葡京娱乐城账号？',
    answer: '点击网站右上角的"注册"按钮，填写手机号或邮箱，设置登录密码，完成手机/邮箱验证即可成功注册。整个过程不超过2分钟。',
  },
  {
    question: '存款和提款需要多长时间？',
    answer: '存款通常即时到账。提款申请在工作时间内最快5分钟处理完成，银行卡提款一般在1-2小时内到账，具体时间取决于银行处理速度。',
  },
  {
    question: '有最低存款和提款限额吗？',
    answer: '最低存款金额为100元，最低提款金额为100元。每日提款上限根据会员等级不同而有所差异，VIP会员享有更高的提款额度。',
  },
  {
    question: '遇到游戏问题怎么办？',
    answer: '您可以随时联系我们的7×24小时在线客服，通过在线聊天、电话或邮件方式获取帮助。客服团队将在3分钟内响应您的问题。',
  },
];

export const stats = [
  { value: '500万+', label: '注册会员' },
  { value: '500+', label: '精选游戏' },
  { value: '99.9%', label: '资金安全率' },
  { value: '24H', label: '客服在线' },
];